import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialImageLeft = {
  factory: EElement({
    id: 'aabfbabe-8b5d-bfc9-c437-c811bd10f84c',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('9738e29c-e366-5d1f-aef5-650877abef46')]),
      children: EList([
        EElement({
          id: 'b104b736-dbcc-2b39-741e-417e1011438f',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '11346d2d-3226-a856-ae12-16b01b886995',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('bfb7054e-191e-e1b2-fd1b-f9031f3dda2e'),
                  ]),
                  children: EList([
                    EElement({
                      id: '32baf4ae-509f-2535-b8b3-110c955a524e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d86d0d12-da18-fc5a-9895-11357f8040d1'),
                        ]),
                        children: EList([
                          EElement({
                            id: '390d6e6f-e37f-4b55-197b-f3d1a00e4b99',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageMountains),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627312199765baa36e654f64"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('e24b3149-e35b-9fbf-452e-7e03cb65044c'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'a2fc0c34-78b5-b903-03b2-5e6db01c1a20',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('80a8e077-da93-56e5-ad9a-f977faddcc3b'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'f804dc20-0d32-5110-05b6-6d702ea6285f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('aa628b64-c4b5-c4f9-785a-65bb602b77c1'),
                                EText('81b4293d-7ffd-4e6e-6399-521969d1771e'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'e08036b2-0d02-299f-759e-9cb5ce63707c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Testimonial introduction copy goes here, lorem ipsum dolor sit amet.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '232b3f9a-150d-858b-5a4b-5e37280b8c18',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('76930344-4e7d-6f0f-1afe-a8373358f485'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '232b3f9a-150d-858b-5a4b-5e37280b8c19',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '7ab86063-3ea8-1588-570b-93665cf94024',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              styleBlockIds: EList([
                                EText('7986b44a-b827-b1d8-8508-c92109cfa10b'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '7ab86063-3ea8-1588-570b-93665cf94025',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Author Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0ebe1259-6cb7-edd6-19c6-81df0e8d5657',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('9cab6300-eb80-0e06-a58b-4ef4d41d66ff'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0ebe1259-6cb7-edd6-19c6-81df0e8d5658',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Co-Founder and CEO of Company'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '9738e29c-e366-5d1f-aef5-650877abef46',
      type: 'class',
      name: 'Testimonial Image Left',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'bfb7054e-191e-e1b2-fd1b-f9031f3dda2e',
      type: 'class',
      name: 'Testimonial Wrapper Four',
      comb: '',
      styleLess: 'display: flex; justify-content: space-between;',
      children: [],
      variants: {small: {styleLess: 'flex-direction: column;'}},
    },
    {
      _id: 'd86d0d12-da18-fc5a-9895-11357f8040d1',
      type: 'class',
      name: 'Testimonial Left',
      comb: '',
      styleLess: 'width: 30%; margin-right: 64px;',
      children: [],
      variants: {
        medium: {styleLess: 'width: 40%; margin-right: 40px;'},
        small: {
          styleLess: 'width: 100%; margin-right: 0px; margin-bottom: 40px;',
        },
      },
    },
    {
      _id: 'e24b3149-e35b-9fbf-452e-7e03cb65044c',
      type: 'class',
      name: 'Testimonial Image Four',
      comb: '',
      styleLess: 'width: 100%; height: 100%; object-fit: cover;',
      children: [],
      variants: {small: {styleLess: 'height: auto;'}},
    },
    {
      _id: '80a8e077-da93-56e5-ad9a-f977faddcc3b',
      type: 'class',
      name: 'Testimonial Right',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; align-items: flex-start; flex-grow: 1; flex-shrink: 1; flex-basis: 0%;',
      children: [],
      variants: {},
    },
    {
      _id: 'aa628b64-c4b5-c4f9-785a-65bb602b77c1',
      type: 'class',
      name: 'Heading Small',
      comb: '',
      styleLess: 'font-size: 32px; line-height: 40px; font-weight: 600;',
      children: ['81b4293d-7ffd-4e6e-6399-521969d1771e'],
      variants: {
        small: {styleLess: 'font-size: 28px; line-height: 36px;'},
        tiny: {styleLess: 'font-size: 24px; line-height: 32px;'},
      },
    },
    {
      _id: '81b4293d-7ffd-4e6e-6399-521969d1771e',
      type: 'class',
      name: 'Margin bottom 32px',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '76930344-4e7d-6f0f-1afe-a8373358f485',
      type: 'class',
      name: 'Testimonial Text Four',
      comb: '',
      styleLess: 'margin-bottom: 32px;',
      children: [],
      variants: {},
    },
    {
      _id: '7986b44a-b827-b1d8-8508-c92109cfa10b',
      type: 'class',
      name: 'Testimonial Author Name Three',
      comb: '',
      styleLess: 'margin-bottom: 10px;',
      children: [],
      variants: {},
    },
    {
      _id: '9cab6300-eb80-0e06-a58b-4ef4d41d66ff',
      type: 'class',
      name: 'Testimonial Title',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
